module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ThumbnailsSlider"
  }, [_c('div', {
    staticClass: "ThumbnailsSlider-prev",
    class: _vm.getPrevBtbClass(),
    on: {
      "click": _vm.handlePrevBtnClick
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  })]), _vm._v(" "), _c('div', {
    staticClass: "ThumbnailsSlider-list"
  }, _vm._l((_vm.thumbsRange), function(thumbnail) {
    return _c('div', {
      key: thumbnail,
      staticClass: "ThumbnailItem",
      class: _vm.getThumbnailClass(thumbnail),
      on: {
        "click": function($event) {
          return _vm.changePage(thumbnail)
        }
      }
    }, [_c('div', {
      staticClass: "ThumbnailItem-img"
    }, [_c('div', {
      staticClass: "ThumbnailItem-img-background",
      style: (_vm.getThumbnailStyle(thumbnail))
    })]), _vm._v(" "), _c('div', {
      staticClass: "ThumbnailItem-text"
    }, [_vm._v("\n\t\t\t\t" + _vm._s(thumbnail) + "\n\t\t\t")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ThumbnailsSlider-next",
    class: _vm.getNextBtnClass(),
    on: {
      "click": _vm.handleNextBtnClick
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1326e6dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ThumbnailsSlider.vue
// module id = 418
// module chunks = 1